export enum AlterationType {
	EXCLUSION_URGENT_EMERGENCY = 2,
	REDUCTION_WITH_IMPACT = 3,
}
